import React, { Component } from "react"
import PropTypes from "prop-types"
import MetaTags from 'react-meta-tags';
import { connect } from "react-redux"
import { Link, withRouter } from "react-router-dom"
import { withTranslation } from "react-i18next"
import {
  Col,
  Container,
  Row,
  Card,
  CardBody,
  CardHeader,
} from "reactstrap"
import { Accordion, AccordionItem, AccordionHeader, AccordionBody } from "reactstrap";
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { map } from "lodash"
import ProjectFilterMenu from "./lead-filter-menu";
import {
  getAllProjectLead
} from "../../../store/actions";
class PendingWorksheetLead extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lead: '',
      openAccordion: null
    }
    
   
  }
   toggleAccordion = (dayTitle) => {
    this.setState((prev) => ({
      openAccordion: prev.openAccordion === dayTitle ? null : dayTitle,
    }));
  };
  componentDidMount() {
    const { onGetAllProjectLead } = this.props;
    onGetAllProjectLead(localStorage.getItem('userId'));
  }
  render() {
    const { allleads } = this.props;
    //var days = [];
    const days = [
      { title: '1 Day', leads: [] },
      { title: '2 Days', leads: [] },
      { title: '3 Days', leads: [] },
      { title: '4 Days', leads: [] },
      { title: 'More than 4 Days', leads: [] }
  ];
  const today = new Date();
  allleads?.reduce((acc, lead) => {
    if (!lead.worksheetSendDate) return acc;
  
    const worksheetDate = new Date(lead.worksheetSendDate);
    const diffInDays = Math.floor((today - worksheetDate) / (1000 * 60 * 60 * 24));
  
    const index = diffInDays >= 4 ? 4 : diffInDays - 1;
    if (index >= 0) acc[index].leads.push(lead);
  
    return acc;
  }, days);
  const {openAccordion} = this.state;
  const {isResponsive} = this.props;
    return (
      <React.Fragment>
        {this.props.loading && this.props.loading ? (
          <div className="loading">Loading&#8230;</div>
        ) : null}
        <div className="page-content project-page-content">
          <MetaTags>
            <title>Projects | Realty Space</title>
          </MetaTags>
          <Container fluid className="ps-0 pe-0">
            {/* Render Breadcrumbs */}

            <Row className="mb20 project-header">
              <Col lg="12">
                <Breadcrumbs
                  title={this.props.t("Project Lead")}
                  breadcrumbItem={this.props.t("Worksheet Pending")}
                />
              </Col>

              {/* <Col lg="6">

              </Col> */}
            </Row>
            <Row>
               <Card className="card-without-border">
              <CardHeader className="">
                   <ProjectFilterMenu />
              </CardHeader>
            </Card>
           
                
                
            </Row>
            <Row>
                  <Col sm="12">
                    <Card>
                      <CardBody>
                        {isResponsive ? (
                           <Accordion open={openAccordion} toggle={this.toggleAccordion}>
              {days.map((day) => (
                <AccordionItem key={day.title}>
                  <AccordionHeader
                    targetId={day.title}
                    style={{
                      //backgroundColor: "#000000",
                      //color: "#FFFFFF",
                      //fontSize: "14px",
                    }}
                  >
                    {day.title}{" "}
                    
                  </AccordionHeader>
                  <AccordionBody accordionId={day.title}>
                    {day.leads && day.leads.length > 0 ? (
                      day.leads.map((lead, idx) => (
                        <div className="card mb-2" key={idx}>
                          <div className="card-body p-2">
                            <div className="fw-bold" style={{ fontSize: 14 }}>
                              <Link
                                to={`/pre-construction/campaign/${lead?.project?.projectGuid}`}
                              >
                                {lead?.project?.projectName}
                              </Link>
                            </div>
                            <div className="text-muted" style={{ fontSize: 13 }}>
                              {lead.firstName} {lead.lastName}
                            </div>
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="text-muted small">No leads</div>
                    )}
                  </AccordionBody>
                </AccordionItem>
              ))}
                            </Accordion>
          
                        ):(
                          <>
                           <Row className="toHeadingRow ">
                          <Col sm="1"></Col>
                        { days.map((day,index) => 
                            <Col sm="2" className="" key={day.title}>
                                <div className="topHeading" style={{backgroundColor:'#000000'}}>
                                  <h4 style={{fontSize:'12px', color:'#FFFFFF'}}>{day.title}</h4>
                                </div>
                            </Col>
                         )} 
                         </Row>  
                         
                         <Row className="toRowContect" style={{marginTop:20}}>
                        <Col sm="1"></Col>
                        { days.map(day => 
                        <Col sm="2" className="" key={day.title}>
                                <div >
                                { day.leads.map(lead => 
                                <div style={{marginBottom:10}} className="container p-0" key={day.name}>
                                  <div className="card custom-card" >
                                    <div className="card-body">
                                      <div className="d-flex align-items-center">
                                        <h5 className="mb-2" style={{fontSize:16}}><Link to={`/pre-construction/campaign/${lead?.project?.projectGuid}`}>Project: {lead?.project?.projectName}</Link></h5>
                                       
                                      </div>
                                     
                                      <div>Name: {lead.firstName	+" "+ lead.lastName}</div>
                                      
                                  </div>
                                </div>
                              </div>
                              )} 
                              
                                   
                                </div>

                               
                            </Col>
                         )}     
                         </Row>      
                          </>
                        )}
                                   
                      </CardBody>
                    </Card>
                  </Col>
                </Row>  
          </Container>
        </div>
      </React.Fragment>
    )
  }
}

PendingWorksheetLead.propTypes = {

  className: PropTypes.any,
  t: PropTypes.any,
  loading:PropTypes.object,
  onGetAllProjectLead:PropTypes.func,
  allleads:PropTypes.array,
  isResponsive:PropTypes.object
}

const mapStateToProps = ({ Project, leads }) => ({
  allleads: Project.allleads,
  loading: Project.loading,
 
})

const mapDispatchToProps = dispatch => ({
  onGetAllProjectLead: (agentId) => dispatch(getAllProjectLead(agentId)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(withTranslation()(PendingWorksheetLead)))